import { ajaxRequest } from "../../Utils/Ajax/ajax"
import { loadSingleTaskFunctionality } from "../../Utils/Tasks/loadSingleTask"
import { successToast } from "../../Utils/utils"

export function loadImporter(){

    $(".import-back").hide()
    loadSingleTaskFunctionality()

    const previousNodes = JSON.parse($("#previous-nodes").val().toString())

    const imports = {
        test: {},
        task: {}
    }

    const deType = {
        topic: ["Thema", "Themen"],
        test: ["AB", "ABs"],
        task: ["Aufgabe", "Aufgaben"]
    }


    $("#import").on("click", ".node-check", function(){
        const node = $(this).parents(".node")
        console.log(node)
        
        const type = node.attr('data-type')
        const nodeId = node.attr('data-node')
        const isChecked = $(this).is(":checked")
        const name = node.find(".node-name").html().toString()
        const tasks = Number(node.find("input[type='checkbox']").attr('data-tasks')) ?? 0

        updateImports(type, Number(nodeId), isChecked, true, name, tasks)
    })

    function currentNode(){
        return Number($("#current-node").val())
    }

    function updateImports(type, nodeId, add=true, renderNew = true, name='', tasks=0){

        const currentNode = Number($("#current-node").val())
        if (add){
            if (type == 'test'){
                imports[type][nodeId] = {
                    name: name,
                    tasks: tasks
                }

                if (nodeId in imports.task){
                    delete imports.task[nodeId]
                }

            } else if (type == 'task'){
                if (imports[type][currentNode] == undefined){
                    imports[type][currentNode] = []
                }
                imports[type][currentNode].push(nodeId)
            }
        } else {
            if (type == "test"){
                delete imports[type][nodeId]
                delete imports.task[nodeId]
            } else if (type == "task"){
                // remove if selected as complete
                if (currentNode in imports.test){
                    // is selected as complete
                    $(".node").each((ind, obj) => {
                        // add as tasks
                        updateImports('task', Number($(obj).attr('data-node')), true, false) // insert all
                    })

                    // remove from selected
                    delete imports.test[currentNode]
                }
                // remove the unselected task from list
                if (imports.task[currentNode] !== undefined){
                    const ind = imports.task[currentNode].indexOf(nodeId)
                    if (ind > -1){
                        imports.task[currentNode].splice(ind, 1)
                    }
                    // remove completely if nothing left
                    if (imports.task[currentNode].length == 0){
                        delete imports.task[currentNode]
                    }
                }

            }
        }


        if (renderNew){
            renderImports()
        }
    }

    // man könnte immer wenn was geladen wird die Daten speichern in einem object -> dann die Namen und so weiter auflisten
    function renderImports(){

        let html = ''
        let empty = true; // if there is anything added rn

        const selectedTests = (Object.keys(imports.test).length > 0) ? Object.keys(imports.test) : []

        for (const [testId, obj] of Object.entries(imports.test)){
            empty = false

            html += '<p> ' + obj.name + ' (' + obj.tasks + " "
            if (obj.tasks == 1){
                html += deType.task[0] // singular
            } else {
                html += deType.task[1] // plural
            }
            html += ')</p>'
        }

        let singleTasks = 0

        for (const [testId, tasks] of Object.entries(imports.task)){
            if (! selectedTests.includes(testId)){
                // is not as a whole test selected
                singleTasks += tasks.length

                if (tasks.length > 0){
                    empty = false
                }
            }
        }

        if (singleTasks > 0){
            html += '<p>' + singleTasks.toString() + ' einzelne '
            if (singleTasks == 1){
                html += deType.task[0] // singular
            } else {
                html += deType.task[1] // plural
            }
            html += '</p>'
        }

        if (empty){
            html = $("#import-list").attr('data-empty')
            $(".import").prop('disabled', true)
        } else {
            $(".import").prop('disabled', false)
        }

        $("#import-list").html(html)
        
    }

    $("#import").on("click", ".import-back", function(){
        const previousNode = previousNodes[previousNodes.length - 1] // get last node
        previousNodes.pop() // remove last node
        loadNode(previousNode["id"], previousNode["type"], $(this))
    })


    $("#import").on("click", ".load-node", function(){
        const nodeId = $(this).parent().attr('data-node')
        const nodeType = $(this).parent().attr('data-type')

        const currentNode = Number($("#current-node").val())

        // check for doppelklick
        const lastPreviousNode = previousNodes[previousNodes.length - 1]
        if (lastPreviousNode !== undefined && lastPreviousNode.id == currentNode && lastPreviousNode.type == nodeType){
            return;
        }
        previousNodes.push({
            id: currentNode,
            type: nodeType
        })

        
        if (nodeType == 'test'){
            loadAbNode(Number(nodeId), nodeType, $(this))
        } else if (nodeType == 'topic'){
            loadNode(Number(nodeId), nodeType, $(this))
        }
    })

    $(".import").on("click", function(){

        const courseId = $("#course-id").val()

        const url = '/import/' + courseId.toString()

        console.log(imports.test)

        const tests = (Object.keys(imports.test).length > 0) ? Object.keys(imports.test).map((value) => { return Number(value)}) : []
        
        let tasks = []
        for (const [testId, testTasks] of Object.entries(imports.task)){
            testTasks.forEach((testTask) => {
                tasks.push(testTask)
            })
        }

        tasks = [...new Set(tasks)];

        const data = {
            tests: tests,
            tasks: tasks
        }

        const success = function (data){
            successToast("Importiert", "Erfolg")
            setTimeout(function(){
                window.location = data.redirect_url
            }, 800);
        }

        ajaxRequest(url, success, data, $(this))
    })


    function markAndAddAllNodes(butNot=[]){ // exclude a node
        $(".node").each((ind, node) => {
            $(node).find("input[type='checkbox']").prop('checked', true)

        })
    }

    function markNodesWithActiveSubnodes(){
        $(".node[data-type='test']").each((ind, node) => {
            const testId = Number($(node).attr('data-node'))
            if (testId in imports.task){
                $(node).find(".node-info").html("Aufgaben teils ausgewählt")
            }
        })
    }


    function loadNode(nodeId:number, nodeType:string, btn:boolean|JQuery = false){

        if (previousNodes.length == 0){
            $(".import-back").hide()
        } else {
            $(".import-back").show()
        }

        const url = '/node/load/' + nodeId.toString()
    
        load(nodeId, nodeType, url, btn)
    }

    function load(nodeId, nodeType, url, btn:boolean|JQuery=false, checked=false,){
        
        const success = function(data){
            $("#nodes").html(data.html)

            if (checked){
                markAndAddAllNodes()
            }

            $("#current-node").val(nodeId)
        }
    
        return ajaxRequest(url, success, {}, btn)
    }

    // TODO: ENDPOINT HINZUFÜGEN | vlt noch anzahl tests und aufgaben mit icons anzeigen immer
    function loadAbNode(nodeId:number, nodeType:string, btn = false){

        const url = '/node/ab/load/' + nodeId.toString()

        const checked = nodeId in imports.test // check if it is checked

        load(nodeId, nodeType, url, btn, checked)
    }

}

